import { Component, OnInit } from '@angular/core';
import { ConceptoFacturacion } from '../../_models/concepto-facturacion';
import { ConceptoFacturacionService } from '../../_services/concepto-facturacion.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-concepto-facturacion-detalle',
  templateUrl: 'concepto-facturacion-detalle.component.html'
} )

export class ConceptoFacturacionDetalleComponent implements OnInit {

  concepto: ConceptoFacturacion;
  carInformacionInicial = true;

  constructor( private conFacturacionServicio: ConceptoFacturacionService,
               private route: ActivatedRoute, private location: Location ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      this.conFacturacionServicio.obtenerPorId( params[ 'id' ] ).subscribe( concepto => {
        this.concepto = concepto;
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
